<template>
    <div class="activities" style="margin-bottom: -20px;">
		<div class="container-fluid">
			<div class="row mt-5">
				<div class="col-12">
					<div id="activity">
						<div class="title-container mt-4">
							<div>
								<h3 class="heading text-center">
									Activities & Workshops
								</h3>
								<hr class="custom-hr">
							</div>
							<div class="filters mt-5">
								<span class="filter" v-bind:class="{ active: currentFilter === 'ACTIVITY' }" v-on:click="setFilter('ACTIVITY')">ACTIVITY</span>
								<span class="filter" v-bind:class="{ active: currentFilter === 'WORKSHOPS' }" v-on:click="setFilter('WORKSHOPS')">WORKSHOPS</span>
								<span class="filter" v-bind:class="{ active: currentFilter === 'COMPETITION' }" v-on:click="setFilter('COMPETITION')">COMPETITION</span>
								<span class="filter" v-bind:class="{ active: currentFilter === 'PERFORMANCE' }" v-on:click="setFilter('PERFORMANCE')">PERFORMANCE</span>
							</div>
						</div>
						<transition-group class="projects" name="projects" >
							<template  v-for="project in projects">
								<div class="project" v-if="currentFilter === project.category || currentFilter === 'ACTIVITY'" v-bind:key="project.title">
									<div class="project-image-wrapper">
										<img class="project-image" v-lazy="project.image">
										<div class="gradient-overlay"></div>
										<div class="circle">
											<span class="project-title">{{project.title}}</span>
										</div>
									</div>
								</div>
							</template>
						</transition-group>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>


<script>
export default {
    data(){
        return{
            currentFilter: 'ACTIVITY',
            projects: [
                // {title: "Artwork", image: "https://images.unsplash.com/photo-1556911073-38141963c9e0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=750&q=80", category: 'ART'},
                {title: "Art", image: require("../assets/images/activities/art/art.jpg"), category: 'ACTIVITY'},
                {title: "Artist Night", image: require("../assets/images/activities/artist night/artistnight.jpg"), category: 'COMPETITION'},
                {title: "Band Performance", image: require("../assets/images/activities/bandperformance/bandperformance.jpg"), category: 'WORKSHOPS'},
                {title: "Cosplay", image: require("../assets/images/activities/cosplay/cosplay.jpg"), category: 'PERFORMANCE'},
                {title: "Culture", image: require("../assets/images/activities/culture/culture.jpg"), category: 'ACTIVITY'},
                {title: "Adventure Sports", image: require("../assets/images/activities/adventure.jpg"), category: 'ACTIVITY'},
                {title: "Exhibition", image: require("../assets/images/activities/exhibition/exhibition.jpg"), category: 'ACTIVITY'},
                {title: "Cycling", image: require("../assets/images/activities/cycl/cycling.jpg"), category: 'WORKSHOPS'},
                {title: "Tattoo", image: require("../assets/images/activities/tattoo.jpg"), category: 'WORKSHOPS'},
                {title: "Film", image: require("../assets/images/activities/films/films.jpg"), category: 'WORKSHOPS'},
                {title: "Theatre", image: require("../assets/images/activities/theature.jpg"), category: 'WORKSHOPS'},
                {title: "Flea", image: require("../assets/images/activities/flea/flea.jpg"), category: 'WORKSHOPS'},
                {title: "Gaming", image: require("../assets/images/activities/gaming/gaming.jpg"), category: 'WORKSHOPS'},
                {title: "Global Water", image: require("../assets/images/activities/global water/globalwater.jpg"), category: 'WORKSHOPS'},
                {title: "Literature", image: require("../assets/images/activities/literature/literature.jpg"), category: 'WORKSHOPS'},
                {title: "Arts", image: require("../assets/images/activities/competition/arts.jpg"), category: 'COMPETITION'},
                {title: "Music", image: require("../assets/images/activities/competition/music.jpg"), category: 'COMPETITION'},
                {title: "Dance", image: require("../assets/images/activities/competition/dance.jpg"), category: 'COMPETITION'},
                {title: "Films", image: require("../assets/images/activities/competition/films.jpg"), category: 'COMPETITION'},
                {title: "Photography", image: require("../assets/images/activities/competition/photography.jpg"), category: 'COMPETITION'},
                {title: "Literature", image: require("../assets/images/activities/competition/literature.jpg"), category: 'COMPETITION'},
            ]
        }
    },
    methods: {
		setFilter: function(filter) {
			this.currentFilter = filter;
		}
	}
}
</script>

<style scoped>

a:hover .active {
	background: red !important;
	color: black !important;
}

.title-container {
	display:flex;
	flex-direction:column;
	justify-content:center;
	align-items:center;
}

.title {
	font-family: 'Dawning of a New Day', cursive;
	font-size:30pt;
	font-weight:normal;
}

.project-title {
	font-size:12pt;
	padding-left: 5px;
	padding-right: 5px;
	/* font-family: Nothing You Could Do; */
	font-weight: normal;	
}
.filters{
    display: flex;
    flex-wrap:wrap;
    justify-content: center;
}

.filter {
    font-size: 1.6rem;
	font-family:arial;
	padding: 10px 16px;
	cursor:pointer;
	/* border-radius: 3px; */
	transition: all 0.35s;
    /* background: #fbd020; */
	/* border: 2px solid transparent; */
	margin-right: 2px;
}

.filter.active, .filter:hover.active {
	/* box-shadow:0px 1px 3px 0px #00000026; */
	background: #4a4a4a;
	color: #fbd020;
	font-weight: bold;
	/* border: 2px solid black; */
}

.filter:hover {
	background:lightgray;
	/* border: 2px solid black; */
}


.filter:focus,
.filter:active{
	background: #4a4a4a Important;
}

.projects {

	margin-bottom:50px;
	margin-top:25px;
	display:flex;
	flex-wrap:wrap;
	justify-content:center;
}

.projects-enter {
	transform: scale(0.5) translatey(-80px);
	opacity:0;
}

.projects-leave-to{
	transform: translatey(30px);
	opacity:0;
}

.projects-leave-active {
	position: absolute;
	z-index:-1;
}

.circle {
	text-align:center;
	position:absolute;
	bottom:13px;
	left:0px;
	min-width:120px;
	max-width: 160px;
	height:33px;
	/* border-radius:50px; */
/* 	border:1px solid black; */
	display:flex;
	box-shadow: 0px -4px 3px 0px #494d3257;
	justify-content:center;
	align-items:center;
	background-color:#fbd020;
/* 	box-shadow:0px -3px 3px #484848a6; */
	clip-path: polygon(0 0, 99% 0, 93% 100%, 0% 100%);
	padding-right: 7px;
}

.project {
	background: #fff;
	transition: all .35s ease-in-out;
	margin:10px;
	box-shadow:0px 2px 8px lightgrey;
	border-radius:3px;
	width:250px;
	height:202px;
	display:flex;
	flex-direction:column;
	align-items:center;
}

.project-image-wrapper {
	position:relative;
    width: 100%;
    height: 200px;
    padding: 0px 2px;
}

.gradient-overlay {
	position:absolute;
	top:0;
	left:0;
	width:100%;
	height:100%;
	opacity:0.09;
	background: 
		linear-gradient(to bottom, rgba(0,210,247,0.65) 0%,rgba(0,210,247,0.64) 1%,rgba(0,0,0,0) 100%), 
		linear-gradient(to top, rgba(247,0,156,0.65) 0%,rgba(247,0,156,0.64) 1%,rgba(0,0,0,0) 100%);
	border-bottom-left-radius:10px;
	border-bottom-right-radius:10px;
	border-top-left-radius:3px;
	border-top-right-radius:3px;
}

.project-image {
	width:100%;
	/* height:150px; */
    height: 100%;
	border-bottom-left-radius:5px;
	border-bottom-right-radius:5px;
	border-top-left-radius:3px;
	border-top-right-radius:3px;
}

@media (max-width: 768px){
	.project{
		/* width: 160px; */
		width: 50%;
		height: auto;
		margin: 5px 0px;
	}
	.project-image{
		object-fit: cover;
		object-position: center;
	}
	.project-title{
		font-size: 11pt;
	}
	.filter{
		font-size: 1.5rem;
		padding: 4px 10px;
	}
}
</style>

